import React, { Component } from "react";

import Modal from 'react-bootstrap/Modal';
import { Button } from "react-bootstrap";
import ButtonIcon from "../../../../button";
import DATEPICKER_OR from "../../../../common/custom-form/custom-date-picker.component";
import { InputField } from "../../../../common/custom-form/input-filter-component";
import { SelectField } from "../../../../common/custom-form/select-filter.component";
import { TextArea } from "../../../../common/custom-form/custom-textarea.component";
export class AddCostCodeModal extends Component {
  constructor(props) {
    super(props);  
    this.onSelectedChange=this.onSelectedChange.bind(this);
    this.state={
      show:false,
      clearData:false, 
      selected:[],
      orderSubmitted:"",
      selectedTwo:[],
      selectFilter:[
        {
            "FilterId":5,
            "FilterName":"Account Number",
            "FilterType":"Textbox",
            "Page":"CircuitInventoryReport",
            "State":true,"Createdby":null,
            "DateCreated":"0001-01-01T00:00:00",
            "Modifiedby":null,
            "DateModified":null,
            "DropDownFilterOpts":null
        },
        {
            "FilterId":4,
            "FilterName":"Circuit ID",
            "FilterType":"Textbox","Page":
            "CircuitInventoryReport",
            "State":true,"Createdby":null,
            "DateCreated":"0001-01-01T00:00:00",
            "Modifiedby":null,
            "DateModified":null,
            "DropDownFilterOpts":null
        },
        {
            "FilterId":7,
            "FilterName":"Circuit Status",
            "FilterType":"Textbox",
            "Page":"CircuitInventoryReport",
            "State":true,"Createdby":null,
            "DateCreated":"0001-01-01T00:00:00",
            "Modifiedby":null,
            "DateModified":null,
            "DropDownFilterOpts":null
        }
       ]
    }
  }
  

  handleClose(){
    this.setState({show:false});
  }

  handleShow() {
    this.setState({show:true});
  }

  onSelectedChange(selected) {
    this.setState({selected:selected})
  }

  onChange = (selected) => {
    this.setState({ selected });
  };
  
  resetClearData(item) {
    this.setState({clearData:item})
  }
 
  render(){
    const {show}=this.state;
    return(
      <>

    
      <ButtonIcon onClick={this.handleShow.bind(this)} iconLeft="file-plus" iconSize="17px" customClassName="header-filter-button" labelName={this.props.labelName}/>
      
      <Modal
        show={show}
        onHide={this.handleClose.bind(this)}
        backdrop="static"
        keyboard={false}
        className="custom-column-modal-container modal-rematch finance-modal-container"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Cost Code Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
           <div className="finance-detail-table">
                        <h1>Level Requirement</h1>
                        <div className="manage-order-container">
                            <div className="manage-order-detail">
                                <InputField label="Level" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                           </div>
                        </div>
                        <h1>Cost Code Information</h1>
                        <div className="manage-order-container">                          
                            <div className="manage-order-detail grid-2-1fr-column">                               
                                <InputField label="Description" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                                <DATEPICKER_OR label="Last Modified" startDate={this.state.invoiceApproveDate} dateSelected={this.state.invoiceApproveDate} selectedDate={(date) => this.setState({invoiceApproveDate:date})}/>
                               
                                <SelectField label="Status"  options={this.state.selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/> 
                                <div></div>
                                <div className="horizontal-separator grid-item-column-span-2"></div>
                                <DATEPICKER_OR label="Valid From" startDate={this.state.invoiceApproveDate} dateSelected={this.state.invoiceApproveDate} selectedDate={(date) => this.setState({invoiceApproveDate:date})}/>
                                <DATEPICKER_OR label="Valid To" startDate={this.state.invoiceApproveDate} dateSelected={this.state.invoiceApproveDate} selectedDate={(date) => this.setState({invoiceApproveDate:date})}/>
                            </div>

                        </div>  
           </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={this.handleClose.bind(this)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={()=>alert("Click Me")}>Save</Button>
        </Modal.Footer>
      </Modal>

      </>
    );
  }
}
